import { Box, Container, Typography, CircularProgress } from "@mui/material";
import BuildIcon from "@mui/icons-material/Build";
import { useEffect, useState } from "react";
import axios from "axios";
import backgroundImage from "../../Assets/P1360983-scaled.jpg";
import mastLogo from "../../Assets/mast_logo.png";

const MaintenancePage = () => {
  const [response, setResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        setIsLoading(true);
        const result = await axios.get("/api/auth/status");
        setResponse(result.data);
        
        // Redirect to home if maintenance is over
        if (result.data && !result.data.isInOutage) {
          window.location.href = "/";
        }
      } catch (err) {
        console.error("Failed to fetch status:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchStatus();
    // Poll every 30 seconds to check if maintenance is over
    const interval = setInterval(fetchStatus, 30000);
    return () => clearInterval(interval);
  }, []);

  if (isLoading) {
    return (
      <Box
        sx={{
          position: "relative",
          minHeight: "100vh",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            filter: "blur(8px)",
            zIndex: -1,
          },
        }}
      >
        <Box
          component="img"
          src={mastLogo}
          alt="MAST Logo"
          sx={{
            position: "absolute",
            top: 20,
            left: 20,
            width: 200,
            height: "auto",
            zIndex: 10,
          }}
        />
        <Container maxWidth="sm">
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "100vh",
            }}
          >
            <CircularProgress sx={{ color: "white" }} />
          </Box>
        </Container>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "100vh",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          filter: "blur(8px)",
          zIndex: -1,
        },
      }}
    >
      <Box
        component="img"
        src={mastLogo}
        alt="MAST Logo"
        sx={{
          position: "absolute",
          top: 20,
          left: 20,
          width: 250,
          height: "auto",
          zIndex: 10,
        }}
      />
      <Container maxWidth="sm">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            textAlign: "center",
            py: 4,
          }}
        >
          <BuildIcon
            sx={{
              fontSize: 120,
              color: "orange",
              mb: 3,
              filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.5))",
            }}
          />
          <Typography 
            variant="h3" 
            component="h1" 
            gutterBottom
            sx={{ 
              color: "white",
              textShadow: "2px 2px 4px rgba(0,0,0,0.7)",
            }}
          >
            System Maintenance
          </Typography>
          <Typography
            variant="h6"
            sx={{ 
              mb: 4, 
              maxWidth: 600,
              color: "white",
              textShadow: "1px 1px 3px rgba(0,0,0,0.7)",
            }}
          >
            {response?.outageMessage ||
              "We're currently performing scheduled maintenance. We'll be back shortly."}
          </Typography>
          <Typography 
            variant="body2" 
            sx={{ 
              color: "white",
              textShadow: "1px 1px 2px rgba(0,0,0,0.7)",
            }}
          >
            Thank you for your patience.
          </Typography>
          <Typography 
            variant="body2" 
            sx={{ 
              mt: 1,
              color: "white",
              textShadow: "1px 1px 2px rgba(0,0,0,0.7)",
            }}
          >
            This page will automatically refresh when the system is back online.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default MaintenancePage;
